import React from 'react';
import { MonthConvert, MonthConvert_year } from './utility'
const trimstre = {
  "first": 'الثلث الأول',
  'second': 'الثلث الثاني',
  'third': 'الثلث الثالث'
}
function PeriodTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >الدورة الشهرية</th>
            <th >أيام التبويض الأكثر احتمالًا</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert(item.startDatePeriods)} - {MonthConvert(item.endDatePeriods)}</td>
              <td>{MonthConvert(item.ovulationWindowStart)} - {MonthConvert(item.ovulationWindowEnd)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function OvulationTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result
    return (
      <table >
        <thead>
          <tr className='highlightedOk'>
            <th className="">الحالة</th>
            <th className="">النتائج</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>تاريخ التبويض الأكثر احتمالًا</td>
            <td>{MonthConvert_year(result.mostProbableOvulationDate)}</td>
          </tr>
          <tr>
            <td>نافذة الجماع للحمل</td>
            <td>{MonthConvert_year(result.intercourseWindowForPregnancy)}</td>
          </tr>
          <tr>
            <td>إختبار الحمل</td>
            <td>{MonthConvert_year(result.pregnancyTest)}</td>
          </tr>
          <tr>
            <td>بداية الدورة الشهرية القادمة</td>
            <td>{MonthConvert_year(result.nextPeriodStart)}</td>
          </tr>
          <tr>
            <td>تاريخ الولادة إذا كنت حاملا</td>
            <td>{MonthConvert_year(result.dueDateIfPregnant)}</td>
          </tr>
        </tbody>
      </table>
    )
  }
}
function OvulationTableV2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result.importantDatesForNextSixMonths
    return (
      <table >
        <thead>
          <tr>
            <th >بداية الدورة الشهرية</th>
            <th >نافذة التبويض</th>
            <th >تاريخ الولادة المتوقعة</th>
          </tr>
        </thead>
        <tbody>
          {response.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.ovulationWindowStart)} - {MonthConvert_year(item.ovulationWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function ConceptionTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >بداية الدورة الشهرية</th>
            <th >نافذة الإخصاب</th>
            <th >تاريخ الولادة المتوقعة</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.conceptionWindowStart)} - {MonthConvert_year(item.conceptionWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function PregnancyTable({ result }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <tr>
            <th >الحالة</th>
            <th > النتائج</th>
          </tr>
          <tr>
            <td > أنت في الأسبوع رقم  </td>
            <td > {response.currentWeek} ( {response.numberOfWeeks} اسبوع و  {response.remainingDays} ويوم <b>أو</b> {response.months} شهر و {response.daysMonth})</td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>تاريخ الولادة المُقدر هو</td>
            <td>{MonthConvert_year(response.dueDate)} </td>
          </tr>
          <tr className="">
            <td> من المرجح أن يكون الحمل قد حدث في </td>
            <td>{MonthConvert_year(response.conceivedDate)} </td>
          </tr>
          <tr className="">
            <td> انتي في</td>
            <td>{trimstre[response.trimstre]} </td>
          </tr>
          <tr className="">
            <td>  لقد اكملتي</td>
            <td>{response.percentageOfPregnancyTime}%  من فترة الحمل</td>
          </tr>
        </tbody>
      </table>
    );
  }
}
function PregnancyWeightTable({ Response, WeightBforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    var range = ""
    var bmi = ''
    if (response.weightclassification === 'higher') { range = "وزنك الحالي أعلى من النطاق الموصى به." }
    if (response.weightclassification === 'lower') { range = "وزنك الحالي أقل من النطاق الموصى به." }
    if (response.weightclassification === 'normal') { range = "وزنك الحالي في النطاق الموصى به." }
    if (response.bmiResult.BMIclassification === 'Underweight') { bmi = 'وزن غير كافٍ' }
    if (response.bmiResult.BMIclassification === 'Normal weight') { bmi = 'وزن طبيعي' }
    if (response.bmiResult.BMIclassification === 'Overweight') { bmi = 'ماقبل السمنة' }
    if (response.bmiResult.BMIclassification === 'Obese') { bmi = 'السمنة' }
    return (
      <table >
        <thead>
          <tr>
            <td > النطاق الموصى به للوزن في الأسبوع رقم {response.week} </td>
            <td > <b>{response.recommended.max}</b> - <b>{response.recommended.min}</b></td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>النطاق الموصى به للوزن عند الولادة (الأسبوع الـ40)</td>
            <td><b>{response.recommendedWeightDelivering.max}</b> - <b>{response.recommendedWeightDelivering.min}</b></td>
          </tr>
          <tr className={response.bmiResult.BMIclassification}>
            <td> <b>({bmi})</b> مؤشر كتلة الجسم (BMI)</td>
            <td><b>{response.bmiResult.BMI}</b> كغ/م2&nbsp;</td>
          </tr>
          <tr className="">
            <td colSpan="3">
              {range}</td>
          </tr>
        </tbody>
      </table>
    );
  }
}
function PregnancyWeight50Table({ Response, WeightBforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    var range = ""
    var bmi = ''
    if (response.weightclassification === 'higher') { range = "وزنك الحالي أعلى من النطاق الموصى به." }
    if (response.weightclassification === 'lower') { range = "وزنك الحالي أقل من النطاق الموصى به." }
    if (response.weightclassification === 'normal') { range = "وزنك الحالي في النطاق الموصى به." }
    if (response.bmiResult.BMIclassification === 'Underweight') { bmi = 'وزن غير كافٍ' }
    if (response.bmiResult.BMIclassification === 'Normal weight') { bmi = 'وزن طبيعي' }
    if (response.bmiResult.BMIclassification === 'Overweight') { bmi = 'ماقبل السمنة' }
    if (response.bmiResult.BMIclassification === 'Obese') { bmi = 'السمنة' }
    return (
      <table >
        <thead>
          <tr>
            <td className='bmi-header'> الاسبوع </td>
            <td className='bmi-header'> نطاق الوزن الموصى به </td>
            <td className='bmi-header'> زيادة الوزن الموصى بها </td>
          </tr>
        </thead>
        <tbody>
          {response.maxWeightValues.map((item, index) => (
            <tr className="">
              <td> الاسبوع {index + 1} </td>
              <td>{WeightBforePregnancy + response.minWeightValues[index]} - {WeightBforePregnancy + response.maxWeightValues[index]}</td>
              <td>{response.minWeightValues[index]} - {response.maxWeightValues[index]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
function ConceptionTablev2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <th >الحالة</th>
          <th > النتائج</th>
          <tr>
            <td >تواريخ الإخصاب الأكثر احتمالًا</td>
            <td > {MonthConvert_year(response.mostProbableConceptionWindowStart)} الى {MonthConvert_year(response.mostProbableConceptionWindowEnd)} </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td >تواريخ العلاقة الجنسية الأكثر احتمالًا التي أدت إلى الحمل</td>
            <td > {MonthConvert_year(response.mostProbableDatesSexualIntercourseStart)} الى {MonthConvert_year(response.mostProbabledatesSexualIntercourseEnd)} </td>
          </tr>
          <tr>
            <td >تواريخ الإخصاب الممكنة </td>
            <td > {MonthConvert_year(response.possibleConceptionWindowStart)} الى {MonthConvert_year(response.possibleConceptionWindowEnd)} </td>
          </tr>
          <tr>
            <td>
              تواريخ العلاقة الجنسية الممكنة التي أدت إلى الحمل:
            </td>
            <td>
              {MonthConvert_year(response.possibleDatesSexualIntercourseStart)} الى {MonthConvert_year(response.possibleDatesSexualIntercourseEnd)}
            </td></tr>
        </tbody>
      </table>
    );
  }
}
function OvulationTableFull({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (<div className="col">
      <p>تواريخ مهمة لهذا الدورة:</p>
      <OvulationTable result={result}></OvulationTable>
      <br></br>
      <br></br>
      <p>تواريخ مهمة للدورات الست التالية:</p>
      <OvulationTableV2 result={result}></OvulationTableV2>
    </div>)
  }
}
function DueDateTable({ result }) {
    return (
      <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td> تاريخ الولادة المُقدر</td>
          <td>{MonthConvert_year(result.dueDate)} </td>
        </tr>
        <tr >
          <td>أنتي في</td>
          <td> الإسبوع  {result.currentWeek} ({result.numberOfWeeks} أسابيع و{result.remainingDays} أيام أو {result.months} شهر و{result.daysMonth} يومًا) من الحمل. </td>
        </tr>
        <tr >
          <td>أنتي في</td>
          <td> {trimstre[result.trimstre]} من فترة الحمل</td>
        </tr>
        <tr >
          <td>لقد أكملتي</td>
          <td> {result.percentageof40week}% من الفترة الكلية للحمل</td>
        </tr>
      </tbody>
    </table>
    )
}
export { DueDateTable,PeriodTable, ConceptionTable, OvulationTable, PregnancyTable, PregnancyWeightTable, PregnancyWeight50Table, ConceptionTablev2, OvulationTableV2, OvulationTableFull };
